import { Link } from "react-router-dom";
import { CheckCircle2, Phone } from "lucide-react";
import { Seo } from "../components/Seo";
import { BIZ, track } from "../data/site";

export default function ThankYou() {
  return (
    <div data-testid="thank-you-page" className="min-h-[80svh] flex items-center">
      <Seo
        title="Thank You — Request Received | Westway Collision Center"
        description="Your estimate request has been received by Westway Collision Center in Carrollton, TX. A master technician will respond within one business hour."
        path="/thank-you"
        robots="noindex, nofollow"
      />
      <div className="max-w-2xl mx-auto px-4 sm:px-6 text-center py-32">
        <CheckCircle2 size={56} className="text-accent mx-auto" strokeWidth={1.3} />
        <h1 className="mt-7 font-display text-3xl sm:text-5xl font-extrabold tracking-tight text-white text-balance">
          Request Received
        </h1>
        <p className="mt-5 text-sm sm:text-base text-slate-400 leading-relaxed">
          Thank you — your photos and details are with our team now. A master technician reviews
          every request and responds within one business hour (Mon–Fri 7:30 AM–6:00 PM,
          Sat 8:00 AM–5:00 PM).
        </p>
        <div className="mt-9 flex flex-col sm:flex-row justify-center gap-4">
          <a
            href={BIZ.phoneHref}
            data-testid="thank-you-call-cta"
            onClick={() => track("click_to_call", { location: "thank_you" })}
            className="inline-flex items-center justify-center gap-2 rounded-full bg-accentdeep px-8 py-4 font-display font-bold text-white transition-all duration-300 hover:bg-accenthover hover:-translate-y-0.5"
          >
            <Phone size={16} />
            Urgent? Call {BIZ.phoneDisplay}
          </a>
          <Link
            to="/"
            data-testid="thank-you-home-link"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 px-8 py-4 font-display font-semibold text-white transition-all duration-300 hover:border-accent/60 hover:text-accent"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
